<style scoped>
.terms-content {
    height: 70vh;
}
</style>

<template>
    <modal type="custom" class="modal-3xl">
        <div class="terms-content overflow-auto">
            <slot></slot>
        </div>
        <div class="flex justify-end mt-3">
            <button
                class="btn font-black px-16 text-lg"
                @click="$emit('close')"
            >
                {{ $t('common.close') }}
            </button>
        </div>
    </modal>
</template>

<script>
import modal from '@/components/modal.vue';
export default {
    components: { modal }
};
</script>
